export default __webpack_public_path__ + "static/media/close_icon_bold.fe6c4016.svg";